var _excluded = ["widget", "title", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import { getWidget, getUiOptions, optionsList, TranslatableString } from '@rjsf/utils';
import isObject from 'lodash/isObject';
/** The `BooleanField` component is used to render a field in the schema is boolean. It constructs `enumOptions` for the
 * two boolean values based on the various alternatives in the schema.
 *
 * @param props - The `FieldProps` for this template
 */

function BooleanField(props) {
  var _a, _b, _c;

  var schema = props.schema,
      name = props.name,
      uiSchema = props.uiSchema,
      idSchema = props.idSchema,
      formData = props.formData,
      registry = props.registry,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      hideError = props.hideError,
      autofocus = props.autofocus,
      title = props.title,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      rawErrors = props.rawErrors;
  var schemaTitle = schema.title;
  var widgets = registry.widgets,
      formContext = registry.formContext,
      translateString = registry.translateString,
      globalUiOptions = registry.globalUiOptions;

  var _getUiOptions = getUiOptions(uiSchema, globalUiOptions),
      _getUiOptions$widget = _getUiOptions.widget,
      widget = _getUiOptions$widget === void 0 ? 'checkbox' : _getUiOptions$widget,
      uiTitle = _getUiOptions.title,
      _getUiOptions$label = _getUiOptions.label,
      displayLabel = _getUiOptions$label === void 0 ? true : _getUiOptions$label,
      options = _objectWithoutProperties(_getUiOptions, _excluded);

  var Widget = getWidget(schema, widget, widgets);
  var yes = translateString(TranslatableString.YesLabel);
  var no = translateString(TranslatableString.NoLabel);
  var enumOptions;
  var label = (_b = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schemaTitle) !== null && _a !== void 0 ? _a : title) !== null && _b !== void 0 ? _b : name;

  if (Array.isArray(schema.oneOf)) {
    enumOptions = optionsList({
      oneOf: schema.oneOf.map(function (option) {
        if (isObject(option)) {
          return _objectSpread(_objectSpread({}, option), {}, {
            title: option.title || (option.const === true ? yes : no)
          });
        }

        return undefined;
      }).filter(function (o) {
        return o;
      }) // cast away the error that typescript can't grok is fixed

    }, uiSchema);
  } else {
    // We deprecated enumNames in v5. It's intentionally omitted from RSJFSchema type, so we need to cast here.
    var schemaWithEnumNames = schema;
    var enums = (_c = schema.enum) !== null && _c !== void 0 ? _c : [true, false];

    if (!schemaWithEnumNames.enumNames && enums.length === 2 && enums.every(function (v) {
      return typeof v === 'boolean';
    })) {
      enumOptions = [{
        value: enums[0],
        label: enums[0] ? yes : no
      }, {
        value: enums[1],
        label: enums[1] ? yes : no
      }];
    } else {
      enumOptions = optionsList({
        enum: enums,
        // NOTE: enumNames is deprecated, but still supported for now.
        enumNames: schemaWithEnumNames.enumNames
      }, uiSchema);
    }
  }

  return _jsx(Widget, {
    options: _objectSpread(_objectSpread({}, options), {}, {
      enumOptions: enumOptions
    }),
    schema: schema,
    uiSchema: uiSchema,
    id: idSchema.$id,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    label: label,
    hideLabel: !displayLabel,
    value: formData,
    required: required,
    disabled: disabled,
    readonly: readonly,
    hideError: hideError,
    registry: registry,
    formContext: formContext,
    autofocus: autofocus,
    rawErrors: rawErrors
  });
}

export default BooleanField;